// extracted by mini-css-extract-plugin
export default {"pageTitle":"style_pageTitle__6ZBTO","title":"style_title__C1q0N","empty":"style_empty__kOJ7B","loader":"style_loader__inPkd"};